<template>
    <div class=" p-4 md:p-8">
        <div class="m-auto article-image-container shadow-xl mb-6">
            <Image :imageUrl="imgSrc" />
        </div>
        <div class="bg-white p-5 shadow rounded">
            <h3 class="md:text-xl mb-6 uppercase font-medium">{{ row.article.name }}</h3>
            <ul>
                <li class="flex mb-1 md:mb-2">
                    <span>{{ translations.article_number }}</span><span class="ml-auto">{{ row.article.external_id }}</span>
                </li>
                <li class="flex mb-1 md:mb-2">
                    <span>{{ translations.size }}</span><span class="ml-auto">{{ row.article.property }}</span>
                </li>
            </ul>
            <div class="mt-6">
                <div class="flex flex-wrap md:flex-row-reverse md:flex-nowrap w-full">
                    <div class="flex flex-col w-full md:w-1/3 md:pl-10">
                        <label :for="'return' + row.id" class="text-base font-medium pb-3 text-right">{{translations.return_this_product}}</label>
                        <input type="checkbox" :id="'return' + row.id" :disabled="toggleArticle" v-model="checked" class="h-12 w-12 disabled:bg-gray-100 input ml-auto">
                    </div>
                    <div class="flex flex-col w-full md:w-2/3">
                        <label for="id" class="text-base font-medium pb-3">{{translations.quantity}}</label>
                        <select :disabled="toggleArticle" class="border disabled:opacity-80 input" v-model="data.quantity" @input="setQuantity($event.target.value)">
                            <option v-for="(quantity, index) in row.amount" :value="index + 1">{{ index +1 }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="mt-4" v-if="isReturn && row.article.reasons" v-show="!toggleArticle">
                <Reasons
                    :isReturn="isReturn"
                    :row="row"
                    v-model="data.reasons"
                    :translations="translations"
                    :toggleArticle="toggleArticle"
                />
            </div>
            <div class="flex flex-col" v-if="row.article.reasons && !isReturn" v-show="checked">
                <template v-for="(quantity, index) in data.quantity" :key="quantity">
                    <BatchCode v-if="row.batch_code && data.batch_codes.length > 0" v-show="data.batch_codes[index].require_batch_code" @update:modelValue="addBatchCode($event, index)" :translations="translations" />
                    <Reasons
                        v-show="!toggleArticle"
                        :isReturn="isReturn"
                        :quantityLabel="quantity"
                        :toggleArticle="checked"
                        :quantity="data.quantity"
                        :row="row"
                        class="mt-4"
                        @update:modelValue="addOrRemoveReason($event, index)"
                        :translations="translations"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Reasons from '@/Components/Reasons'
import BatchCode from '@/Components/BatchCode'
import Image from './Image.vue'
import Input from './Input.vue'
export default {
    components: {
        Reasons,
        Image,
        BatchCode,
        Input,
    },
    props: {
        toggleArticle: Boolean,
        row: Object,
        translations: Object,
        isReturn: Boolean,
        addedGlobalReasons: Object
    },
    data() {
        return {
            checked: false,
            imgSrc: '',
            debounce: null,
            data: {
                'article_id': this.row.article_id,
                'order_id':this.row.order_id,
                'order_row_id':this.row.id,
                'batch_codes': this.row.batch_code ? [] : null,
                'quantity': 1,
                'reasons': this.row.article.reasons ? [] : null,
            },
        }
    },
    watch: {
        data: {
            deep: true,
            handler() {
                this.triggerEmit();
            }
        },
        addedGlobalReasons: {
            deep: true,
            handler() {
                for (let index = 0; index < this.data.quantity; index++) {
                    this.hasBatchCode(index, this.addedGlobalReasons)
                }
            }
        },
        toggleArticle(val) {
            this.checked = val
            this.resetState(val)
        },
        checked(val) {
            this.triggerEmit()
        },
    },
    methods: {
        resetState(val) {
            const amount = val ? this.row.amount : 1
            this.setQuantity(amount)
            this.data.reasons = this.row.article.reasons ? [] : null
        },

        triggerEmit() {
            if(this.checked) {
                this.$emit('update:modelValue', this.data)
            }
            else {
                this.$emit('update:modelValue', null)
            }
        },

        async getImageUrl() {
            const { data } = await axios.post('/image', this.row.article)
            this.imgSrc = data
        },

        addOrRemoveReason(reasons, indexQuantity) {
            if(!this.data.reasons[indexQuantity]) {
                this.data.reasons[indexQuantity] = []
            }
            reasons.forEach(reason => {
                let alreadyAdded = false
                reason.quantity_id = indexQuantity
                this.data.reasons[indexQuantity].forEach(addedReason => {
                    if(addedReason.id == reason.id) {
                        alreadyAdded = true
                    }
                });
                if(!alreadyAdded) {
                    this.data.reasons[indexQuantity].push(reason)
                }
            });

            this.data.reasons[indexQuantity].forEach((reasonAdded, index) => {
                let found = false
                reasons.forEach(reason => {
                    if(reason.id == reasonAdded.id) {
                        found = true
                    }
                });
                if(!found) {
                    this.data.reasons[indexQuantity].splice(index, 1)
                }
            });
            this.hasBatchCode(indexQuantity, this.data.reasons[indexQuantity])
        },

        includesBatchCode(indexQuantity) {
            return this.data.batch_codes.map(function(code) {
                return code.quantity_id;
            }).indexOf(indexQuantity);
        },

        createBatchCodes(indexQuantity) {
            for (let index = 0; index < indexQuantity; index++) {
                if(this.includesBatchCode(index) === -1) {
                    this.data.batch_codes.push({
                        quantity_id: index,
                        code: '',
                        require_batch_code: true
                    })
                }
            }
        },

        addBatchCode(code, index) {
            this.data.batch_codes[index].code = code
        },

        hasBatchCode(index, reasons) {
            if(this.data.batch_codes) {
                this.data.batch_codes[index].require_batch_code = this.showBatchCodeInput(reasons)
            }
        },

        //Only show batch code input if correct supplier, and no reasons are selected which disable batch code. Example missing item.
        showBatchCodeInput(reasons) {
            let show = true
            reasons.forEach(reason => {
                if(reason.disable_batch_code) {
                    show = false
                }
            })
            return show
        },

        setQuantity(quantity) {
            if(this.data.batch_codes) {
                this.createBatchCodes(parseInt(quantity))
                if(this.data.batch_codes.length > 0) {
                    this.data.batch_codes.length = parseInt(quantity)
                }
            }
            this.data.quantity = parseInt(quantity)
        }
    },
    mounted() {
        this.setQuantity(1)
        this.getImageUrl()
    }
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>


<style>
    .multiselect__tags {
        min-height: 58px;
        padding: 16px 40px 0 8px;
    }
    .multiselect__select {
        height: 56px;
    }
    .multiselect__placeholder, .multiselect__placeholder__custom {
        font-size: 15px;
        /* color: black; */
        padding-top: 0;
        font-weight: 400;
    }
</style>
